import { useConfirm } from 'primevue/useconfirm';

export interface ConfirmOptions {
  message: string;
  header?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  icon?: string;
  acceptClass?: string;
  rejectClass?: string;
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

/**
 * Promise-returning confirm dialog backed by PrimeVue's ConfirmDialog.
 * Replaces legacy `$confirm({title, text, ok, cancel}).then(...)` usage.
 *
 * Resolves true when the user accepts, false when they reject (or dismiss).
 */
export function useAppConfirm(): ConfirmFn {
  const confirm = useConfirm();

  return (options) =>
    new Promise<boolean>((resolve) => {
      confirm.require({
        message: options.message,
        header: options.header ?? 'Are you sure?',
        acceptLabel: options.acceptLabel ?? 'Yes',
        rejectLabel: options.rejectLabel ?? 'No',
        icon: options.icon ?? 'pi pi-exclamation-triangle',
        acceptClass: options.acceptClass,
        rejectClass: options.rejectClass,
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
}
